import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { http } from '@/api/client';
import { keys, useInvalidate } from '@/api/hooks';
import { platform } from '@/platform';

const SLIDES = [
  { ic: '🌙', t: 'Каждый день — новая карта', d: 'Откройте карту дня и узнайте, на что обратить внимание сегодня.' },
  { ic: '✨', t: 'Задайте вопрос — карты ответят', d: 'Три карты и живая трактовка под ваш вопрос. Можно дополнить расклад.' },
  { ic: '🕯️', t: 'Украсьте свой стол', d: 'Скатерти, свечи, статуэтки, питомец и новые колоды — из магазина и гачи.' },
];

export function OnboardingScreen() {
  const [i, setI] = useState(0);
  const nav = useNavigate();
  const invalidate = useInvalidate();
  const s = SLIDES[i]!;
  const last = i === SLIDES.length - 1;

  const finish = async () => {
    await http.post('/me/onboarded');
    await invalidate(keys.me);
    nav('/', { replace: true });
  };

  return (
    <div className="onb">
      <div className="onb-art">{i === 0 && <div className="onb-card"><span style={{ backgroundImage: 'url(/assets/decks/deck_classic/major_17_star.webp)' }} /></div>}{i === 1 && <div className="onb-three">{['major_00_fool', 'major_10_wheel', 'major_19_sun'].map((k, j) => <span key={k} style={{ backgroundImage: `url(/assets/decks/deck_classic/${k}.webp)`, '--i': j - 1 } as React.CSSProperties} />)}</div>}{i === 2 && <img className="onb-img" src="/assets/brand/onboarding_3.svg" alt="" />}</div>
      <h1>{s.t}</h1>
      <p className="muted">{s.d}</p>
      <div className="dots">{SLIDES.map((_, k) => <i key={k} className={k === i ? 'on' : ''} />)}</div>
      <div style={{ width: '100%', maxWidth: 320, display: 'grid', gap: 8, marginTop: 12 }}>
        <button className="btn primary" onClick={() => { platform.haptic('light'); last ? void finish() : setI(i + 1); }}>{last ? 'Начать' : 'Далее'}</button>
        {!last && <button className="btn ghost" onClick={() => void finish()}>Пропустить</button>}
      </div>
      <p className="dim">Стартовый подарок: 100 кристаллов и билет на крутку</p>
    </div>
  );
}
